import React, { useState, useEffect } from "react";
import "./search-bar.scss";
// import { BsSearch } from "react-icons/bs";
import Icon from "../../assets/images/search-icon1.png";

function SearchBar({ callback }) {
  const [state, setstate] = useState("");
  // Filter posts on typing in search input
  const handleChange = (e) => {
    setstate(e.target.value);
  };

  useEffect(() => {
    callback(state,true);
  }, [state]);

  return (
    <>
      <form action="" className="flexy col-md-12">
        <div className="search-div col-md-12">
          <div className="search-bar  ">
            {" "}
            <input
              type="search"
              name="search"
              pattern=".*\S.*"
              required
              onChange={handleChange}
              value={state.query}
            />
            <button className="search-btn" type="submit"></button>
          </div>
        </div>
      </form>
      {/*<ul>{state.list.length === 0 && <h3>Empty List !!!</h3>}</ul>*/}
    </>
  );
}

export default SearchBar;
